import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';
import moment from 'moment';

import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import Input, { InputLabel } from 'material-ui/Input';
import Chip from 'material-ui/Chip';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from 'material-ui/Dialog';
import ExpansionPanel, {
    ExpansionPanelDetails,
    ExpansionPanelSummary
} from 'material-ui/ExpansionPanel';
import Typography from 'material-ui/Typography';
import { ListItemText } from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from 'material-ui/Divider';
import { MenuItem } from 'material-ui/Menu';
import Select from 'material-ui/Select';
import { FormControl } from 'material-ui/Form';

import * as Utils from '../../../lib/designerUtils';
import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';
import * as LibraryState from '../../../state/reducer/library/library';

import Console from '../../../lib/debug';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 40 * 4.5 + 8,
            width: 250
        }
    },
    onEnter: () => {
        setTimeout(() => {
            if (document.activeElement) {
                document.activeElement.blur();
            }
        }, 500);
    }
};

class ExportAsProgramModal extends Component {
    state = {
        name: '',
        sports: [],
        expanded: null,
        difficulty: 2
    };

    componentWillMount() {
        LibraryState.loadSports();
    }

    programNameInputField = () => {
        return (
            <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Program Name *"
                placeholder="Ex. 2 Week Strength Cycle"
                fullWidth
                type="text"
                value={this.state.name}
                onChange={this.handleChange('name')}
            />
        );
    };

    sessionCount = () => {
        return _.keys(this.props.sessions).length;
    };

    weekIndexes = () => {
        let days = this.props.dayTree;
        return _.map(this.props.sessions, session => {
            let dayKey = Utils.getDayKey(moment(session.data.date));
            let foundDay = days[dayKey];
            if (!foundDay) return 0;
            return foundDay.weekIndex;
        });
    };

    weekCount = () => {
        let weekIndexes = this.weekIndexes();
        return _.uniq(weekIndexes).length;
    };

    exportInfo = () => {
        let sessionCount = this.sessionCount();
        let weekCount = this.weekCount();
        const className =
            'export-stat layout-row layout-align-space-between-center';
        return (
            <div className="layout-column">
                <div className={className}>
                    <span className="export-label">Length:</span>
                    <span className="info">
                        {weekCount} Week{weekCount > 1 ? 's' : ''}
                    </span>
                </div>
                <div className={className}>
                    <span className="export-label">Sessions:</span>
                    <span className="info">
                        {sessionCount} Session{sessionCount > 1 ? 's' : ''}
                    </span>
                </div>
            </div>
        );
    };

    getSports = () => {
        let sports = [];
        for (let i = 0; i < this.state.sports.length; i++) {
            let sportObj = _.find(
                this.props.sportRef,
                refObj => refObj.title === this.state.sports[i]
            );
            if (sportObj) {
                sports.push(sportObj);
            }
        }
        return sports;
    };

    handleClose = () => {
        ClipboardState.showExportAsProgram(false);
        ClipboardState.clearSelected();
    };

    handleSave = () => {
        let sessions = ClipboardState.getSelectedSessions();
        sessions = _.sortBy(sessions, session => session.date);

        if (!sessions.length) return ClipboardState.showExportAsProgram(false);

        let firstSessionDate = moment(sessions[0].date);
        sessions = _.map(sessions, session => {
            let day = moment(session.date).diff(firstSessionDate, 'days') + 1;
            return { ...session, day };
        });

        let program = {
            name: this.state.name,
            focus: this.getSports(),
            difficulty: this.state.difficulty,
            description: this.state.description,
            weeks: this.weekCount(),
            sessions
        };
        ClipboardState.showExportAsProgram(false);
        LibraryState.exportProgramToLibrary(program);
        ClipboardState.clearSelected();
    };

    handlePanelChange = panel => (event, expanded) => {
        this.setState({ expanded: expanded ? panel : false });
    };

    advancedSection = () => {
        const { expanded } = this.state;
        let text = expanded ? 'Show Less' : 'Show More';
        return (
            <ExpansionPanel
                className="export-advanced"
                expanded={expanded === 'advancedPanel'}
                onChange={this.handlePanelChange('advancedPanel')}
            >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography style={{ color: '#0645AD' }}>{text}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    {this.advancedOptions()}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    advancedOptions = () => {
        let sports = _.sortBy(this.props.sportRef, 'title');
        return (
            <div>
                <FormControl className="export-select">
                    <InputLabel htmlFor="difficulty-open-select">
                        Difficulty
                    </InputLabel>
                    <Select
                        value={this.state.difficulty}
                        onChange={this.handleChange('difficulty')}
                        inputProps={{
                            name: 'difficulty',
                            id: 'difficulty-open-select'
                        }}
                    >
                        <MenuItem value={1}>Beginner</MenuItem>
                        <MenuItem value={2}>Intermediate</MenuItem>
                        <MenuItem value={3}>Advanced</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className="export-select">
                    <InputLabel htmlFor="select-multiple-chip">
                        Focus
                    </InputLabel>
                    <Select
                        multiple
                        value={this.state.sports}
                        onChange={this.handleChange('sports')}
                        input={
                            <Input
                                id="select-multiple-chip"
                                className="sportChipInput"
                                fullWidth
                            />
                        }
                        renderValue={selected => (
                            <div className="sportChip">
                                {selected.map(sport => (
                                    <Chip key={sport} label={sport} />
                                ))}
                            </div>
                        )}
                        MenuProps={MenuProps}
                    >
                        {sports.map(sport => (
                            <MenuItem key={sport.id} value={sport.title}>
                                <Checkbox
                                    checked={
                                        this.state.sports.indexOf(sport.title) >
                                        -1
                                    }
                                />
                                <ListItemText primary={sport.title} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    margin="dense"
                    id="description"
                    label="Description"
                    fullWidth
                    type="text"
                    multiline
                    value={this.state.description}
                    onChange={this.handleChange('description')}
                />
            </div>
        );
    };

    submitEnabled = () => {
        return this.state.name && this.state.name != '';
    };

    render() {
        Console.render('ExportAsProgramModal');
        let dialogContent = null;
        if (this.props.enabled) {
            dialogContent = (
                <DialogContent>
                    {this.programNameInputField()}
                    {this.exportInfo()}
                    <DialogContentText className="export-info">
                        You can reuse and place this program template on any
                        calendar.
                    </DialogContentText>
                    <br />
                    {this.advancedSection()}
                </DialogContent>
            );
        }

        return (
            <Dialog
                open={this.props.enabled}
                onClose={this.handleClose}
                aria-labelledby="export-program-form"
            >
                <DialogTitle>Export to Program Library</DialogTitle>
                {dialogContent}
                <Divider />
                <DialogActions>
                    <Button onClick={this.handleClose}>Cancel</Button>
                    <Button
                        onClick={this.handleSave}
                        disabled={!this.submitEnabled()}
                        color="primary"
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        dayTree: state.calendar.dayTree,
        enabled: state.clipboard.exportAsProgramModalEnabled,
        sessions: state.clipboard.selectedSessions,
        sportRef: state.library.sportRef
    };
};

export default connect(mapStateToProps)(ExportAsProgramModal);
